import React, { useState, useEffect, useRef } from 'react'
import { Modal, Form, Select, Input, Button, message, Switch, DatePicker, Alert, Space, Spin } from 'antd'
import { PlusCircleOutlined, SaveOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { myHospitals, sendDataBody, updateData, usuario } from '../../resources';
import { createEvent } from './auth.button';


export function CreateCitaForm(props) {

    const { configuracion: { costo_cita = 0, tratamientos_ofrecidos = [] } = {} } = usuario;

    myHospitals.forEach(h => { h.value = h._id; h.label = h.nombre; });

    const servicios = tratamientos_ofrecidos.map((t) => ({ key: t._id, value: t._id, label: t.observaciones ? `${t.tratamiento} - ${t.observaciones}` : t.tratamiento, title: t.tratamiento }))

    // El Select de Servicio usa labelInValue ({key, value, label}), pero la cita guardada
    // solo trae "servicio" (string) e "id_servicio" (id) sueltos: se reconstruye la forma
    // esperada para que, si el médico no la vuelve a tocar al editar, no se pierda el dato.
    const initialServicio = props.cita?.servicio
        ? { key: props.cita.id_servicio, value: props.cita.id_servicio, label: props.cita.servicio }
        : undefined

    // Select patient for create cita
    const [pacientes, setPacientes] = useState([])
    const [pacientesLoading, setPacientesLoading] = useState(false)

    const searchDebounce = useRef(null)

    // Body of cita
    const [usesCostoBase, setUsesCostoBase] = useState(false)
    const [costo, setCosto] = useState(0)

    const fetchPacientes = (search = "") => {
        setPacientesLoading(true)
        sendDataBody('pacientes/medicos/search/name', { medicos: [usuario._id], search })
            .then(data => {
                const results = Array.isArray(data) ? data : []
                results.forEach(p => { p.label = p.name; p.value = p._id })
                // En edición, si el paciente de la cita no viene en los resultados,
                // se inyecta como opción para que el Select muestre su nombre y no su id
                if (props.cita?.usuario && !results.some(p => p._id === props.cita.usuario)) {
                    results.unshift({
                        ...props.cita.paciente,
                        _id: props.cita.usuario,
                        label: props.cita.paciente?.name || props.cita.usuario,
                        value: props.cita.usuario,
                    })
                }
                setPacientes(results)
            })
            .finally(() => setPacientesLoading(false))
    }

    useEffect(() => {
        fetchPacientes()
    }, [])

    // Form Methods
    const onFinish = (values) => {

        values.medico = usuario._id;
        if (values.servicio) {
            values.id_servicio = values.servicio.key;
            values.servicio = values.servicio.label;
        }
        delete values.tratamiento;

        console.log(values)

        // Handle if its updating or creating cita
        if (props.cita) {
            updateData(`citas/update/${props.cita._id}`, values).then((response) => {
                console.log(response)
            }).finally(() => { props.getCitasData(); props.setIsModalOpen(false); props.setEditingCita(false) })
        } else {

            props.isGoogleSincronized && createEvent(values.fecha_hora, values.duracion, values.servicio.title || values.servicio) // Create cita google W

            sendDataBody('citas/add', values).then((response) => {
                message.success(response.message || response.error);
                response.message && response.message === 'Cita creada correctamente' ? createBalance(response.id_nueva_cita, values.fecha_hora) : message.error('No se pudo crear registro de ingreso')
                console.log(response)
            }).finally(() => { props.getCitasData(); props.setIsModalOpen(false) })
        }
    };

    // Create the respective balance for cita
    const createBalance = (_cita, _fecha_hora) => {
        const balanceBody = {
            tipo: 'ingreso',
            medico: usuario._id,
            cita: _cita,
            monto: usesCostoBase ? (costo + costo_cita) : costo,
            forma_de_pago: 'efectivo',
            fecha_hora: _fecha_hora,
            estado: 'pendiente'
        }
        console.log('Balance ready to send: ', balanceBody)
        sendDataBody('balances/add', balanceBody).then((rs) => { message.success(rs.message || rs.error); console.log(rs) })
    }

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const handleHospitalChange = (value) => { console.log('Selected Hospital: ', value); };
    const handlePatientChange = (value) => { console.log('Selected Paciente: ', value); };

    const handleChange = (selected) => {
        const service = tratamientos_ofrecidos.find(t => t._id === selected.value);
        setCosto(service?.costo ?? 0);
        console.log(`selected service`, selected);
    };

    const onSwitch = (checked) => {
        console.log(`switch to ${checked}`);
    };
    const onSwitchCosoBase = (checked) => {
        console.log(`switch to ${checked}`);
        setUsesCostoBase(checked)
    };

    const timeOptions = [
        { label: 'Media Hora', value: 30 },
        { label: 'Una Hora', value: 60 },
        { label: 'Una Hora y Media', value: 90 },
        { label: 'Dos Horas', value: 120 },
        { label: 'Dos Horas Y Media', value: 150 },
        { label: 'Tres Horas', value: 180 },
    ]

    return <Form name="nueva_cita_admin" layout="vertical" onFinish={onFinish} onFinishFailed={onFinishFailed} autoComplete="off"
        initialValues={props.cita ? { ...props.cita, servicio: initialServicio } : { isOnline: false, tratamiento: 'Sin servicio', fecha_hora: props.fecha_hora, duracion: 60 }}
        style={{ marginTop: 16 }}
    >
        {
            myHospitals.length < 1 && <Alert message="Debes tener horarios registrados para poder registrar citas, puedes configurarlos en 'Mi perfil'" type="error" showIcon style={{ marginBottom: 16 }} />
        }

        {!tratamientos_ofrecidos.length && (
            <Alert message="Debes tener servicios registrados para poder registrar citas, puedes configurarlos en 'Mi perfil' y después 'configuracion'" type="error" showIcon style={{ marginBottom: 16 }} />
        )}

        <Form.Item label={<b>Paciente</b>} name="usuario" rules={[{ required: true, message: 'Selecciona Usuario' }]} >
            <Select
                options={pacientes}
                onChange={handlePatientChange}
                onSearch={(val) => {
                    clearTimeout(searchDebounce.current)
                    searchDebounce.current = setTimeout(() => fetchPacientes(val), 400)
                }}
                showSearch
                filterOption={false}
                loading={pacientesLoading}
                notFoundContent={pacientesLoading ? <Spin style={{ display: 'flex', alignSelf: 'center', justifyContent: 'center' }} size="small" /> : 'Sin resultados'}
                placeholder="Buscar paciente..."
            />
        </Form.Item>

        <Form.Item label={<b>Hospital</b>} name="sucursal" rules={[{ required: true, message: 'Selecciona Sucursal' }]} >
            <Select options={myHospitals} onChange={handleHospitalChange} />
        </Form.Item>

        <div style={{ display: 'flex', gap: '16px' }}>
            <Form.Item label={<b>Fecha y Hora</b>} name="fecha_hora" rules={[{ required: false, message: 'Selecciona Fecha y Hora' }]} style={{ flex: 1 }}>
                <DatePicker showTime format="DD/MM/YYYY HH:mm" use12Hours={true} style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item label={<b>Duración</b>} name="duracion" rules={[{ required: true, message: 'Selecciona la duracion de la cita' }]} style={{ flex: 1 }}>
                <Select options={timeOptions} />
            </Form.Item>
        </div>

        {
            !!tratamientos_ofrecidos.length &&
            <Form.Item label={<b>Servicio</b>} name="servicio" rules={[{ required: true, message: 'Selecciona un servicio' }]} >
                <Select
                    onChange={handleChange}
                    options={servicios}
                    labelInValue
                />
            </Form.Item>
        }

        <Form.Item label={<b>¿Consulta en línea? (Videollamada)</b>} name="isOnline" >
            <Switch onChange={onSwitch} checkedChildren="Sí" unCheckedChildren="No" />
        </Form.Item>

        <Form.Item label={<b>Comentarios adicionales</b>} name="comentarios" rules={[{ required: false, message: 'Ingresa Comentarios' }]} >
            <Input.TextArea rows={2} placeholder="Escribe aquí cualquier detalle extra..." />
        </Form.Item>

        <Form.Item label={`costo de la cita $${costo_cita}`} >
            <Switch onChange={onSwitchCosoBase} />
        </Form.Item>

        <Form.Item>
            <div className='fila'>
                <h6>Costo Total: ${usesCostoBase ? (costo + costo_cita) : costo} </h6>
            </div>
        </Form.Item>

        {
            // Only if updating cita
            props.cita && <div style={{ textAlign: 'right', marginTop: '24px' }}>
                <Button type="primary" htmlType="submit" form='nueva_cita_admin' icon={<SaveOutlined />}>
                    Guardar Cambios
                </Button>
            </div>
        }

    </Form >
}
export default function CreateCita(props) {

    // Handle Modal Visibility
    const handCreateleOk = () => { props.setIsModalOpen(false) }
    const handCreateleCancel = () => { props.setIsModalOpen(false) }
    return (
        <Modal
            title={
                <Space>
                    <PlusCircleOutlined style={{ color: '#1677ff', fontSize: '20px' }} />
                    <span style={{ fontSize: '18px', fontWeight: 600 }}>Nueva Cita</span>
                </Space>
            }
            open={props.isOpenModal}
            onOk={handCreateleOk}
            onCancel={handCreateleCancel}
            destroyOnClose
            width={600}
            centered
            footer={[
                <Button key="cancel" onClick={handCreateleCancel} icon={<CloseCircleOutlined />}>Cancelar</Button>,
                <Button key="save" type="primary" htmlType="submit" form='nueva_cita_admin' icon={<SaveOutlined />}>
                    Guardar
                </Button>
            ]}
        >

            <CreateCitaForm setIsModalOpen={props.setIsModalOpen} isOpenModal={props.isCreateModalOpen} fecha_hora={props.fecha_hora} getCitasData={props.getCitasData} />
        </Modal>
    )
}
